// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './app'
import router from 'vue-router'
import echarts from 'echarts'
import ElementUI from 'element-ui'
/**
 * 引入公用样式
 */
import 'res/css/bootstrap.min.css?v=3.3.6'
import 'res/css/font-awesome.min.css?v=4.4.0'
import 'res/css/animate.css'
import 'res/css/style.css?v=4.1.0'
import 'element-ui/lib/theme-chalk/index.css'
import 'res/css/bthStyle.css'

 /**
 * 引入全局js
 */
import 'res/js/jquery.min.js?v=2.1.4'
import 'res/js/bootstrap.min.js?v=3.3.6'
// import 'res/js/plugins/layer/layer.min.js'

/**
 * 引入自定义js
 */
// import 'res/js/welcome.js'

 /**
 * 引入第三方插件js
 */
// import 'res/js/plugins/pace/pace.min.js'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/module/main/main.js